export interface EnvConfig {
  API_URL: string;
  API_KEY: string;
}

let env: EnvConfig | null = null;

export const setEnv = (config: EnvConfig) => {
  env = config;
};

export const getEnv = () => {
  if (!env) {
    throw new Error("Env not initialized");
  }
  return env;
};
